import { IImage, IProcessRawImageRequest } from '@topshots/core-models';
import { topshotsAPI } from '../../app/api';
// import { Image } from '../images/images.types';

const imagesApi = topshotsAPI.injectEndpoints({
  endpoints: (build) => ({
    getImage: build.query<IImage, string>({
      query: (id) => ({
        url: `images/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, page) => [
        { type: 'Images' as const, id: result?._id.toString() },
      ],
    }),
    deleteImage: build.mutation<IImage, string>({
      query: (id) => ({
        url: `images/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, product) => [
        { type: 'Images', id: 'PARTIAL-LIST' },
        { type: 'Images', id: result?._id.toString() },
      ],
    }),
    deleteImages: build.mutation<string[], string[]>({
      query: (ids) => ({
        url: `images`,
        method: 'DELETE',
        params: new URLSearchParams(ids.map((id) => ['ids', id])),
      }),
      invalidatesTags: (result, error, product) => [
        { type: 'Images', id: 'PARTIAL-LIST' },
        ...(result?.map((id) => ({ type: 'Images' as const, id })) ?? []),
      ],
    }),
    requestRawProcessing: build.mutation<void, IProcessRawImageRequest>({
      query: (data) => ({
        url: 'images/process',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const {
  endpoints: { requestRawProcessing },
  useGetImageQuery,
  useDeleteImageMutation,
  useDeleteImagesMutation,
  useRequestRawProcessingMutation,
} = imagesApi;
